// Tipos locais compartilhados entre AnalyticsComercialView.tsx e seus blocos extraídos.

export interface AnaliseCadastralEmbed {
    decisao_final?: string | null;
    decisao_final_at?: string | null;
}

export interface NegRow {
    id: number;
    status: string;
    stage: string;
    segmento?: string | null;
    cliente_nome?: string | null;
    consumo_medio_kwh: number;
    responsavel_id?: string | null;
    motivo_perda?: string | null;
    created_at: string;
    data_assinatura_termo?: string | null;
    ultima_atividade_at?: string | null;
    cidade?: string | null;
    origem?: string | null;
    analise_cadastral?: AnaliseCadastralEmbed[];
    /** Data de geração de cada simulação — usada como "data do evento" da etapa Simulação
     * no funil por data de evento (ver eventFunnel.ts). */
    url_simulacao?: Array<{ data_criacao?: string | null }> | null;
    /** Data de geração de cada termo — usada como "data do evento" da etapa Termo Enviado. */
    url_termo?: Array<{ data_criacao?: string | null }> | null;
    /** Só para a lista que abre ao clicar num card (mesma do Painel Executivo). */
    cpf_cnpj?: string | null;
    tipo_cliente?: string | null;
    /** #6331: data, motivo e se a data foi reconstruída — etapa "Termo Reprovado". */
    termo_reprovado_em?: string | null;
    termo_reprovado_motivo?: string | null;
    termo_reprovado_aproximado?: boolean | null;
}

export type RankingSortKey = 'kwh_aprovado' | 'qtd_aprovados' | 'kwh_assinado' | 'qtd_assinados' | 'conversao';

export const RANKING_SORT_OPTIONS: Array<{ value: RankingSortKey; label: string }> = [
    { value: 'kwh_aprovado', label: 'kWh aprovado' },
    { value: 'qtd_aprovados', label: 'Qtd. aprovados' },
    { value: 'kwh_assinado', label: 'kWh assinado' },
    { value: 'qtd_assinados', label: 'Qtd. assinados' },
    { value: 'conversao', label: 'Conversão ponta a ponta' },
];

/** Painel de Status: `em_analise` = na fila da validação de dados; `com_pendencia` = já analisado, esperando o cliente. */
export type StatusBucket = 'em_analise' | 'com_pendencia' | 'aprovados' | 'reprovados' | 'outros';

export const STATUS_BUCKET_LABELS: Record<StatusBucket, string> = {
    em_analise: 'Em validação de dados',
    com_pendencia: 'Com pendência',
    aprovados: 'Aprovados',
    reprovados: 'Reprovados',
    outros: 'Outros',
};
